:host {
  display: block;
  --klevu-popup-height: 500px;
}

.content {
  display: flex;
  padding: var(--klevu-spacing-04);
  max-width: 800px;
}

.content aside {
  max-width: 180px;
  flex-shrink: 0;
  padding-right: var(--klevu-spacing-04);
  border-right: 1px solid var(--klevu-color-neutral-4);
  margin-right: var(--klevu-spacing-04);
}

klevu-suggestions-list,
klevu-popular-searches,
klevu-cms-list {
  margin-bottom: var(--klevu-spacing-05);
}

klevu-product-grid.desktop {
  width: 600px;
}

.content section {
  max-width: 600px;
}

.resultheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--klevu-spacing-05);
}

klevu-pagination {
  margin-top: var(--klevu-spacing-05);
}

.tabrow:not(:empty) {
  border-bottom: 1px solid var(--klevu-color-neutral-5);
}

.tabrow klevu-tab {
  position: relative;
  bottom: -1px;
}

klevu-moi {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  box-sizing: border-box;
  padding: var(--klevu-spacing-03);
  z-index: 10000;
}

.content aside klevu-button {
  display: none;
}

@media (max-width: 600px) {
  klevu-product-grid.mobile {
    display: flex;
  }

  .content {
    flex-direction: column;
    left: 0;
    width: calc(100vw - 60px);
  }

  .content aside {
    width: 100%;
    border: none;
  }

  .content aside klevu-button {
    display: block;
    float: right;
  }
}

.noResultsMessage {
  text-align: center;
  border-bottom: 1px solid var(--klevu-color-neutral-5, #d6d6d6);
}

.noResultsBannerImage {
  max-width: 100%;
  margin-top: var(--klevu-spacing-04);
}

.topbanners {
  margin-bottom: var(--klevu-spacing-05);
}

.bottombanners {
  margin-top: var(--klevu-spacing-05);
}
